import { apiWithAuth } from "./utils";

export class Campaign {
  constructor(private readonly mountPath: string) {}

  // Create a new campaign
  async createCampaign(campaignData: { [key: string]: any }) {
    return await apiWithAuth.post(this.mountPath, campaignData);
  }

  // Get campaign by ID
  async getCampaignById(id: number) {
    return await apiWithAuth.get(`${this.mountPath}/${id}`);
  }

  // List all campaigns (optionally with filters or pagination)
  async listCampaigns(queryParams: { [key: string]: any } = {}) {
    const queryString = new URLSearchParams(queryParams).toString();
    return await apiWithAuth.get(`${this.mountPath}?${queryString}`);
  }

  // Update campaign by ID
  async updateCampaign(id: number, updateData: { [key: string]: any }) {
    return await apiWithAuth.put(`${this.mountPath}/${id}`, updateData);
  }

  // Delete campaign by ID
  async deleteCampaign(id: number) {
    return await apiWithAuth.delete(`${this.mountPath}/${id}`);
  }

  // Bulk upload campaigns via Excel (FormData)
  async bulkUploadCampaigns(formData: FormData) {
    return await apiWithAuth.post(`${this.mountPath}/bulk-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // Mark campaign as completed
  async completeCampaign(id: number) {
    return await apiWithAuth.post(`${this.mountPath}/${id}/complete`);
  }

  // Send campaign
  async sendCampaign(id: number) {
    return await apiWithAuth.post(`${this.mountPath}/${id}/send`);
  }

  // Duplicate campaign
  async duplicateCampaign(id: number) {
    return await apiWithAuth.post(`${this.mountPath}/${id}/duplicate`);
  }

  // Get campaign analytics
  async getCampaignAnalytics(id: number) {
    return await apiWithAuth.get(`${this.mountPath}/${id}/analytics`);
  }

  // Resend failed delivery record
  async resendDeliveryRecord(deliveryRecordId: number) {
    return await apiWithAuth.post(`${this.mountPath}/delivery-records/${deliveryRecordId}/resend`);
  }
}
